<template>
  <div :class="{box: true, closeAnimation}">
    <div class="title-nav">
      <div class="title">Log in</div>
      <div class="close">
        <font-awesome-icon icon="times" class="icon" @click="close"/>
      </div>
    </div>
    <div class="input-box">
      <div class="frame">
        <div class="name" :class="{ name_error: login_emailError }"><span class="label">e-mail</span><span class="error">{{ login_emailError }}</span></div>
        <div class="input">
          <input type="text" name="login" v-model="login_email" :class="{ input_error: login_emailError }" @input="login_emailError = ''">
        </div>
      </div>
    </div>
    <div class="input-box">
      <div class="frame">
        <div class="name" :class="{ name_error: passwordError }">
          <span class="label">password</span>
          <span class="error">{{ passwordError }}</span>
        </div>
        <div class="input">
          <input type="password" name="password" v-model="password" :class="{ input_error: passwordError }" @input="passwordError = ''" @keypress.enter="submit">
        </div>
      </div>
    </div>
    <div class="button">
      <div class="frame">
        <div class="forgot" @click="resetPassword">Forgot password?</div>
        <div class="forgot"></div>
        <button @click="submit">
          <span v-if="!loading">Log in</span>
          <Loader v-if="loading" color="white" :auto="true"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import alert from '@/lib/alert'
import validator from 'validator';
import axios from 'axios';
import passwordValidator from 'password-validator';
import Loader from '@/components/Loader'

let schema = new passwordValidator();
schema
.is().min(8)
.is().max(30)
.has().uppercase()
.has().lowercase()
.has().digits()
.has().not().spaces()
.is().not().oneOf(['Passw0rd', 'Password123']);

export default {
  name: 'LoginBox',
  data() {
    return {
      login_email: '',
      login_emailError: '',
      login_or_email: '',
      password: '',
      passwordError: '',
      loading: false,
      closeAnimation: false,
      nextLink: null
    }
  },
  components: {
    Loader
  },
  methods: {
    checkLoginEmail() {
      let error = false;

      if(this.login_email.trim() == '') {
        error = true;
        this.login_emailError = 'is required';
        this.login_email = '';
      } else if(!validator.isEmail(this.login_email)) {
          error = true;
          this.login_emailError = 'is invalid';
          this.login_email = '';
        } else {
          this.login_or_email = 'email';
        }

      if(error) {
        return false
      } else {
        return true
      }
    },
    checkPassword() {
      let error = false;

      if(this.password.trim() == '') {
        error = true;
        this.passwordError = 'is required';
        this.password = '';
      } else if(!schema.validate(this.password)) {
        error = true;
        this.passwordError = 'is invalid';
        this.password = '';
      }

      if(error) {
        return false
      } else {
        return true
      }
    },
    submit() {
      if(!this.login_emailError && !this.passwordError) {
        const validLoginEmail = this.checkLoginEmail()
        const validPassword = this.checkPassword()
        if(validLoginEmail && validPassword) {
          this.request()
        }
      }
    },
    request() {
      this.loading = true;
      axios.post(`${process.env.VUE_APP_SERVER_URL}login`, {
        login_email: {
          type: this.login_or_email,
          value: this.login_email
        },
        password: this.password,
      })
      .then(response => {
        this.loading = false;
        localStorage.setItem("token", response.data.token);
        if(this.nextLink) {
          location.replace(this.nextLink);
        } else {
          this.$router.push('/main');
        }
      })
      .catch(error => {
        this.loading = false;
        if(error.message == 'Network Error') {
          this.emitError('Network Error');
        } else if(error.response.data.error == 'invalid login') {
          this.login_email = '';
          this.password = '';
          this.login_emailError = 'does not exist'
        } else if(error.response.data.error == 'invalid password') {
          this.password = '';
          this.passwordError = 'is incorrect'
        } else if(error.response.data.error == 'server error') {
          this.emitError('Server not responding, try later');
        }
      });
    },
    emitError(text) {
      // this.setError(text);
      alert.showError(text);
    },
    close() {
      this.closeAnimation = true;
      setTimeout(() => {
        this.$emit('close');
      }, 200);
    },
    resetPassword() {
      this.$emit('resetPassword', this.login_email);
    }
  }
}
</script>

<style lang="scss" scoped>
  .box {
    position: fixed;
    z-index: 100;
    top: calc(50vh - 12.5rem);
    left: calc(50vw - 12.5rem);
    width: 25rem;
    height: 25rem;
    background-color: whitesmoke;
    border-radius: 0.3rem;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: start 0.2s forwards ease;
    filter:drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.212));

    @media (max-width: 600px) {
      position: absolute;
      top: 6rem;
      width: 90vw;
      left: calc(50vw - 45vw);
    }
  }

  .closeAnimation {
    animation: close 0.2s forwards ease;
  }

  .title-nav {
    width: 100%;
    height: 4rem;
    display: flex;
    flex-direction: row;
    background-color: #11b6a5;
    margin-bottom: 3rem;

    .title {
      width: 8rem;
      height: auto;
      display: flex;
      align-items: center;
      color: white;
      font-size: 1.5rem;
      padding-left: 2rem;
    }

    .close {
      width: 4rem;
      height: 4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: auto;
      color: white;
      font-size: 1.2rem;

      .icon {
        transition: 0.2s;

        &:hover {
          opacity: 0.8;
          cursor: pointer;
        }
      }
    }
  }

  .input-box {
    width: 100%;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .frame {
      width: 18rem;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    
    .name {
      width: 100%;
      height: 2rem;
      display: flex;
      align-items: center;
      font-size: 1.1rem;
      color: rgb(172, 169, 169);

      .label {
        font-weight: bold;
      }

      .error {
        margin-left: 0.5rem;
        font-style: italic;
      }
    }

    .name_error {
      color: rgb(239, 70, 70);
    }

    .input_error {
      border-color: rgb(239, 70, 70) !important;
    }

    .input {
      width: 100%;
      flex: auto;
      display: flex;

      input {
        width: 100%;
        height: 2rem;
        background: none;
        border: none;
        outline: none;
        background-color: rgb(226, 225, 225);
        font-size: 1rem;
        color: rgb(37, 38, 41);
        transition: 0.2s;
        border: 1px rgb(202, 201, 201) solid;
        border-radius: 0.1rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;

        @media (max-width: 600px) {
          height: 2.5rem;
        }
      }

      input:focus {
        border-color: #11b6a5;
      }
    }
  }

  .button {
    width: 100%;
    flex: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .frame {
      width: 18rem;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .forgot {
      font-size: 1rem;
      color: #0ea394;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    button {
      width: 6rem;
      height: 2.5rem;
      background-color: #11b6a5;
      border: none;
      outline: none;
      border-radius: 0.3rem;
      color: white;
      font-size: 1.3rem;
      position: relative;
      z-index: 1;
      overflow: hidden;
      transition: 0.2s;
    }
    
    button:hover {
      cursor: pointer;
      background-color: #10a394;
    }
  }


//Box Start Animation

@keyframes start {
  0% {
    transform: translateY(5rem);
    opacity: 0;
  }
  100% {
    transform: translateY(0rem);
    opacity: 1;
  }
}

@keyframes close {
  0% {
    transform: translateY(0rem);
    opacity: 1;
  }
  100% {
    transform: translateY(-5rem);
    opacity: 0;
  }
}
</style>